module.exports = __webpack_public_path__ + "static/media/settingsNotifications.57f18474.svg";